import {
    definitions,
    paths,
} from "../../common-fetch/generated/orders-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/orders/country/subdivisions"];
export type Responses = Path["get"]["responses"];

export type FetchStatesOutput = FetchOutput<
    Responses["200"]["schema"],
    definitions["ProblemDetails"]
>;

export async function fetchGetStates(countryIso: string): Promise<FetchStatesOutput> {
    const url = `/orders/country/subdivisions?countryIso=${countryIso}`;
    return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
        "authorization",
        `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${url}`
    ).catch(() => {
        return { tag: "client-error", parsed: { status: 418 } };
    });
}
